import { CommonModule } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatDividerModule } from "@angular/material/divider";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatStepperModule } from "@angular/material/stepper";
import { ZXingScannerModule } from "@zxing/ngx-scanner";
import { QRCodeModule } from "angularx-qrcode";
import { Form10AInformation } from "app/api/models";
import { DLMSharedModule } from "app/views/calibrations/shared/shared.module";
import { DragScrollModule } from "ngx-drag-scroll";
import { NgxPrintModule } from "ngx-print";

class Form10aWithQr {
  public qrJson: string;
  public form10a: Form10AInformation;
}

@Component({
  selector: "app-generate-qr-code-dialog",
  templateUrl: "./generate-qr-code-dialog.component.html",
  styleUrls: ["./generate-qr-code-dialog.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    DLMSharedModule,
    MatCardModule,
    MatProgressBarModule,
    MatRadioModule,
    MatCheckboxModule,
    MatButtonModule,
    MatIconModule,
    MatStepperModule,
    MatMenuModule,
    ReactiveFormsModule,
    MatSelectModule,
    FormsModule,
    MatInputModule,
    MatDividerModule,
    MatSlideToggleModule,
    DragScrollModule,
    QRCodeModule,
    ZXingScannerModule,
    NgxPrintModule,
    MatAutocompleteModule,
  ]
})
export class GenerateQrCodeDialogComponent implements OnInit {
  public form10aInfo: Form10aWithQr[] = [];

  constructor(
    public dialogRef: MatDialogRef<GenerateQrCodeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    if (this.data?.form10a != null) {
      var form10a = this.data.form10a;

      this.form10aInfo = [];
      this.form10aInfo.push({
        qrJson: JSON.stringify(form10a.form10aId),
        form10a: form10a,
      });
    } else if (this.data?.form10as != null) {
      this.form10aInfo = [];

      for (var form10a of this.data.form10as)
        this.form10aInfo.push({
          qrJson: JSON.stringify(form10a.form10aId),
          form10a: form10a,
        });
    }
  }

  print() {
    console.log("PRINT HERE");
  }

  close() {
    this.dialogRef.close();
  }
}
